export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">关于我们</h2>
          </div>
          <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                宅男视频是一个专注在线视频流畅播放的内容聚合平台。我们深度接入<strong>久久视频</strong>、<strong>小蓝视频</strong>和<strong>豆花视频</strong>
                三大稳定视频平台，覆盖电影、电视剧、综艺、动漫、纪录片等全品类影视内容，致力于为每一位用户提供
                不缓冲、不卡顿的高清流畅观影体验。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                我们的核心优势在于自研的智能加速播放引擎，支持多线路自动切换，即便在高峰时段也能保持极速流畅。
                内容方面，每日同步更新最新影视资源，确保用户第一时间看到想看的内容。目前平台月活跃用户突破百万，
                深受广大影迷和追剧爱好者的信赖与喜爱。
              </p>
              <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">100万+</div>
                  <div className="text-xs text-foreground-600 mt-1">月活跃用户</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">3大</div>
                  <div className="text-xs text-foreground-600 mt-1">稳定片源平台</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-secondary-500">每日</div>
                  <div className="text-xs text-foreground-600 mt-1">内容更新频率</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">99.9%</div>
                  <div className="text-xs text-foreground-600 mt-1">播放稳定性</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}